export default __webpack_public_path__ + "static/media/splash.3d8c5220.png";